import { defineNuxtRouteMiddleware } from '#app/composables/router';
import { QUERY_PARAMS } from '~/constants/auth';
import { useAuth } from '~/stores/auth';
import { useSystemInfo } from '~/stores/system-info';
import { isUnderTest } from '~/utils/env/is-under-test';
import { isGuestOrPublicRoute } from '~/utils/routes';

export default defineNuxtRouteMiddleware(async (to) => {
	if (isUnderTest())
		return;

	if (isGuestOrPublicRoute(to)) {
		return;
	}

	const systemInfo = useSystemInfo();
	const [{ loggedIn }] = await Promise.all([useAuth(), systemInfo.ensureLoaded()]);

	if (!loggedIn.value) {
		if (systemInfo.requireCreateUser) {
			return {
				name: 'auth.create-user',
				query: {
					[QUERY_PARAMS.redirect]: to.fullPath,
				},
			};
		}

		return {
			name: 'auth.login',
			query: {
				[QUERY_PARAMS.redirect]: to.fullPath,
			},
		};
	}
});
